import PrimaryButton from "../buttons/PrimaryButton";
import Icon1 from "../icons/Icon";
import SecondaryButton from "../buttons/SecondaryButton";
import UploadInvoice from "../api/upload/UploadInvoice";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import { useSnackbar } from "notistack";
import { Switch, useTheme } from "@mui/material";
import SmallSpinner from "../loading/SmallSpinner";
import { useNavigate } from "react-router-dom";
import Space from "../layout/Space";
import { use, useEffect, useState } from "react";

import { useAppContext } from "../config/AppContext";
import deleteDocApi from "../api/database/deleteDocApi";
import { addActivityLog } from "../config/OnlineStatus";

import getTemporaryUrlV2 from "../api/getTemporaryUrlV2";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { isFolderAdmin } from "../pages/folder_pages/FolderHelpers";
import { getDocDataByRef } from "../models/DataFunctions";

const ReglementFolderDevis = ({
  orgData,
  userData,
  folderData,

  handleFetchData,

  loadingTransfer,
  setLoadingTransfer,
  transferFiles,

  dropped_exists,
  navigateWorkspace,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [loadingInvoice, setLoadingInvoice] = useState(false);
  const [devis, setDevis] = useState([]);

  const handleFetchDevisObjects = async () => {
    let devis = [];
    for (const invoice of folderData.invoices || []) {
      if (invoice.ref) {
        let devisData = (await getDocDataByRef(invoice.ref)) || null;
        devis.push(devisData);
      }
    }
    setDevis(devis);
  };

  const handleTransferFiles = async (docId) => {
    setLoadingTransfer(docId);
    await transferFiles(docId);
    setLoadingTransfer(null);
  };

  const handleLoadInvoice = async (invoice) => {
    if (invoice.file.id) {
      setLoadingInvoice(invoice.file.id);
      const token = await getOrRefreshFirebaseToken();
      let refreshed_url = await getTemporaryUrlV2(
        invoice.file.id,
        token,
        prefix
      );
      if (refreshed_url) {
        window.open(refreshed_url, "_blank");
      } else {
        handleClickVariant("Impossible de charger le fichier", "error");
      }
      setLoadingInvoice(false);
    }
  };

  const handleRemoveInvoice = async (invoice) => {
    setLoadingInvoice(invoice.file.id);
    let new_invoices = folderData.invoices.filter(
      (inv) => inv.file?.id !== invoice.file?.id
    );
    await updateDocDataFieldApi(
      folderData.ref,
      "invoices",
      new_invoices,
      prefix
    );
    await addActivityLog(
      "Devis supprimé",
      folderData.ref,
      orgData.id,
      userData.id,
      "invoice_deleted",
      prefix
    );

    handleFetchData();
    handleClickVariant("Devis supprimé", "success");
    setLoadingInvoice(false);
  };

  useEffect(() => {
    handleFetchDevisObjects();
  }, [folderData]);

  return (
    <div className="w-full h-fit flex flex-col p-2 gap-1">
      <div className="flex flex-col gap-2 text-h3 text-black ">
        <div className="flex flex-row justify-between">
          Devis{" "}
          <div className="w-8 h-fit">
            <UploadInvoice
              folderId={folderData.id}
              onUpdate={handleFetchData}
              prefix={prefix}
            ></UploadInvoice>
          </div>
        </div>
        {folderData.invoices?.map((invoice, index) => (
          <div
            key={index}
            className="bg-white px-1 py-1 flex flex-col   gap-1 rounded-md  text-h4 text-shadow_50 border-1 border-shadow_10"
          >
            {devis[index]?.pennylane?.devis_id && (
              <div className="flex flex-col">
                <div className="text-h5 text-green-500 w-fit  px-2 py-1 rounded-md border-green-200 border-1 bg-green-50">
                  Devis généré sur Pennylane
                </div>
              </div>
            )}{" "}
            <div
              onClick={() => handleLoadInvoice(invoice)}
              className="hover:text-indigo-500 text-h5 py-1 px-2 border-1 rounded-md border-indigo-200 bg-indigo-50 w-full hover:underline cursor-pointer"
            >
              {invoice.file.name?.substring(0, 30)}
            </div>
            {loadingInvoice === invoice.file.id && (
              <SmallSpinner></SmallSpinner>
            )}
            {isFolderAdmin(orgData, folderData) && (
              <div className="flex flex-row items-center w-full">
                <div
                  className="cursor-pointer hover:text-red-500  ml-auto "
                  onClick={() => handleRemoveInvoice(invoice)}
                >
                  <Icon1
                    icon_name="delete"
                    fill="grey"
                    hover_color={"red"}
                    size={16}
                  ></Icon1>
                </div>
                {invoice?.ref && (
                  <div
                    className="
                    hover:shadow-xl hover:scale-105
                    w-fit cursor-pointer bg-white border ml-2 rounded-md px-2 py-1  "
                    onClick={() => {
                      navigateWorkspace("/invoice/" + invoice?.ref.id);
                    }}
                  >
                    <Icon1 icon_name="open" size={16}></Icon1>
                  </div>
                )}
              </div>
            )}
          </div>
        ))}
        {isFolderAdmin(orgData, folderData) && (
          <>
            {dropped_exists && (
              <PrimaryButton
                className="h-full w-fit animate-shimmer rounded-2xl "
                onClick={() => handleTransferFiles("devis")}
                disabled={
                  loadingTransfer !== undefined && loadingTransfer !== null
                }
              >
                <div>
                  <div className="flex flex-row gap-1 items-center">
                    {loadingTransfer === "devis"
                      ? "Transfert en cours ..."
                      : "Transférer ici"}
                    <SmallSpinner
                      loading={loadingTransfer === "devis"}
                      margin={0}
                      size={20}
                    />
                  </div>
                </div>
              </PrimaryButton>
            )}
          </>
        )}
      </div>
      {!folderData.invoices && (
        <div className="flex flex-row gap-2 text-h3 text-shadow_50 my-1">
          <Icon1 icon_name="linked_file" size={20} fill={"grey"}></Icon1>
          Pas de devis associé
        </div>
      )}
    </div>
  );
};

export default ReglementFolderDevis;
